// Accepted tokens come from the beacon-commons-tokens meta tag (the contribution
// service exposes no token-list endpoint). Privacy labels per master design §6.

export type TokenCfg = { symbol: string; contract: string; decimals: number; chainId: number };

export function parseTokens(json: string | null | undefined): TokenCfg[] {
  if (!json) return [];
  let raw: unknown;
  try {
    raw = JSON.parse(json);
  } catch {
    return [];
  }
  if (!Array.isArray(raw)) return [];
  const out: TokenCfg[] = [];
  for (const e of raw) {
    if (
      e && typeof e === "object" &&
      typeof (e as TokenCfg).symbol === "string" &&
      typeof (e as TokenCfg).contract === "string" &&
      typeof (e as TokenCfg).decimals === "number" &&
      typeof (e as TokenCfg).chainId === "number"
    ) {
      const t = e as TokenCfg;
      out.push({ symbol: t.symbol, contract: t.contract, decimals: t.decimals, chainId: t.chainId });
    }
  }
  return out;
}

// Human network names for the chains a token can live on. Shown in the chip-in
// flow so a supporter sends on the RIGHT chain — funds sent on another network
// reach a same-looking address but are never detected (the watcher only reads
// the configured RPC's chain). Unknown ids fall back to "chain <id>".
const CHAIN_NAMES: Record<number, string> = {
  1: "Ethereum",
  11155111: "Ethereum Sepolia",
  8453: "Base",
  84532: "Base Sepolia",
  10: "Optimism",
  42161: "Arbitrum One",
  137: "Polygon",
  42220: "Celo",
  100: "Gnosis",
  56: "BNB Chain",
};

export function chainName(chainId: number): string {
  return CHAIN_NAMES[chainId] ?? `chain ${chainId}`;
}

/** Honest per-rail privacy class (master §6/§7). Returns the i18n key suffix. */
export function railPrivacyKey(rail: string): string {
  if (rail.includes("xmr")) return "commons.privacy.hidden";
  if (rail.includes("paypal") || rail.includes("wero") || rail.includes("custodial")) {
    return "commons.privacy.custodial";
  }
  return "commons.privacy.public"; // evm/btc and default: hidden in public, briefly seen by this instance
}
